module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/2023/2023_designexpo_logo-big-694dc938181ecf2f8f5c8c1a2327239e.svg&quot;;"